module.exports = __webpack_public_path__ + "img/lbl-01.a28e7c92.png";